module.exports = __webpack_public_path__ + "img/s-1.ce4b742b.svg";